const paymentsCalls = {
  async payments_subscription_plan({ dispatch }) {
    return dispatch('api_call', {
      endpoint: 'payments/subscription/plan/',
      hasCancel: false,
      mutation: 'api_payments_subscription_plan',
    })
  },
  async payments_subscription_plan_v2({ dispatch }) {
    return dispatch('api_call', {
      endpoint: 'payments/subscription/plan/',
      hasCancel: false,
      mutation: 'api_payments_subscription_plan',
      apiVersion: 'v2',
      useCache: false,
    })
  },
  async payments_subscription_paypal({ dispatch }) {
    const res = await dispatch('api_call', {
      method: 'post',
      endpoint: 'payments/subscription/paypal/',
      mutation: 'api_payments_subscription_paypal',
    })
    return res
  },
  async payments_subscription_stripe_customer({ dispatch }) {
    const res = await dispatch('api_call', {
      method: 'post',
      endpoint: 'payments/subscription/stripe/customer/',
      mutation: 'api_payments_subscription_stripe_customer',
    })
    return res
  },
}

export default paymentsCalls
